module.exports = "<div style=\"min-height: 38.4em;\"></div>"